import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import React, { FC } from "react";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import Typography from "@insite/mobius/Typography";
import Link from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import { connect } from "react-redux";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import getColor from "@insite/mobius/utilities/getColor";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";


const mapStateToProps = (state: CustomApplicationState) => {
	const searchParams = parseQueryString<{ id: string }>(getLocation(state).search);
	return {
		quoteCartId: searchParams?.id,
	};
};

export interface BrickSuccessPageStyles {
	successInfo?: InjectableCss;
	btnWrapper?: InjectableCss;
	successHeading?: InjectableCss;
}

interface OwnProps {
	extendedStyles?: BrickSuccessPageStyles;
	css?: StyledProp;
}

export const brickSuccessPageStyles: BrickSuccessPageStyles = {
	successHeading: {
		css: css`
			margin-bottom: 30px;
			h1{
				font-size: 26px;
				line-height: 32px;
				letter-spacing: 0.5px;
				text-transform: none;
				font-weight: 700;
			}
		`
	},
	successInfo: {
		css: css`
			font-size: 14px;
			color:  ${getColor("text.main")};
			font-weight: 400;
			p{
				margin-bottom: 10px;
			}
			strong{
				margin-bottom: 15px;
				display: block;
			}
		`
	},
	btnWrapper: {
		css: css`
			a{
				background: linear-gradient(to bottom, ${getColor("primary.main")} 0%, #eab100 100%);
				border-radius: 10px;
				color:  ${getColor("text.main")} !important;
				font-size: 14px;
				padding: 9px 20px;
				text-align: center;
				span{
					color:  ${getColor("text.main")} !important;
				}
				${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
						width: 100%;
						display:block;
					`,
						css`
						width: 100%;
						display:block;
					`,
						null,
					],
					"max",
				)}
				
				&:hover{
					span{
						color: ${WhitecapColors.white} !important;
					}
				}
				
			}
		`
	}
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const BrickSuccessPage: FC<Props> = ({ extendedStyles, quoteCartId }) => {
	const styles = mergeToNew(brickSuccessPageStyles, extendedStyles);
	return (
		<StyledWrapper>
			<StyledWrapper {...styles.successHeading}>
				<Typography as="h1">{translate("Your quote request has been received!")}</Typography>
			</StyledWrapper>
			<StyledWrapper {...styles.successInfo}>
				<Typography as="strong">{translate("Thank you for your interest!")}</Typography>
				<Typography as="p">{translate(`Your Quote Request # is: ${quoteCartId}`)}</Typography>
				<Typography as="p">{translate(`We'll email you a Quote Request confirmation email with a link to track progress.`)}</Typography>
			</StyledWrapper>
			<StyledWrapper {...styles.btnWrapper}>
				<Link href="/" >{translate("Continue Shopping")}</Link>
			</StyledWrapper>
		</StyledWrapper>
	);
};


const widgetModule: WidgetModule = {
	component: connect(mapStateToProps)(BrickSuccessPage),
	definition: {
		displayName: "Brick Success Page",
		group: "Common",
	},
};


export default widgetModule;
